export const PARTNERS = {
  '2018': {
    title: 'Correção comentada do gabarito',
    name: 'Kuadro',
    year: 2018,
    description: 'Quer ver a correção comentada do Gabarito Extraoficial? Acesse o nosso parceiro.',
    enem_correction_url: 'https://www.kuadro.com.br/gabarito/enem/',
    image_path: 'kuadro.png',
    link: 'https://www.kuadro.com.br/'
  },
  '2019': {
    title: 'Correção comentada do gabarito',
    name: 'Anglo',
    year: 2019,
    description: 'Clique no botão abaixo e veja as respostas comentadas pelos professores do Anglo.',
    enem_correction_url: 'https://que.bo/CorrecaoEnem',
    image_path: 'logo-anglo.png',
    link: 'http://cursoanglo.com.br/'
  },
  '2020': {
    title: 'Correção comentada do gabarito',
    name: 'Anglo',
    year: 2020,
    description: 'Clique no botão abaixo e veja as respostas comentadas pelos professores do Anglo.',
    enem_correction_url: 'https://que.bo/CorrecaoEnem',
    image_path: 'logo-anglo.png',
    link: 'http://cursoanglo.com.br/'
  },
  '2021': {
    title: 'Correção comentada do gabarito',
    name: 'Anglo',
    year: 2021,
    description: 'Clique no botão abaixo e veja as respostas comentadas pelos professores do Anglo.',
    enem_correction_url: 'https://querobolsa.com.br/revista/correcao-comentada-enem-2021',
    image_path: 'logo-anglo-dark.png',
    link: 'http://cursoanglo.com.br/'
  },
  '2022': {
    title: 'Correção comentada do gabarito',
    name: 'Anglo',
    year: 2022,
    description: 'Clique no botão abaixo e veja as respostas comentadas pelos professores do Anglo.',
    enem_correction_url: 'https://que.bo/CorrecaoEnem',
    image_path: 'logo-anglo-dark.png',
    link: 'http://cursoanglo.com.br/'
  },
};
